module.exports = fox._r("images/video-placeholder.gif", __webpack_public_path__ + "images/video-placeholder.gif");


//////////////////
// WEBPACK FOOTER
// ./images/video-placeholder.gif
// module id = 1028
// module chunks = 4